import { keys } from "@/lib/i18n/portal";
import { useLocale, useTranslations } from "@/lib/i18n/intl";
import { statusLabel } from "../services/selection";
import type { SimulatorSnapshot } from "../types/simulator.types";

const copy = keys.integrationSimulator;
const fields = [
  ["order", "status"], ["order", "paidAmount"], ["order", "requiredAmount"],
  ["order", "totalAmount"], ["payment", "status"], ["payment", "amount"],
  ["payment", "capturedAmount"], ["shipment", "status"],
] as const;
export function RealSimulatorState({ before, after, currency }: { before: SimulatorSnapshot | null; after?: SimulatorSnapshot | null; currency: string }) {
  const t = useTranslations();
  const locale = useLocale();
  const money = new Intl.NumberFormat(locale, { style: "currency", currency });
  function value(field: string, raw: unknown) {
    if (field === "status") return statusLabel(raw, t);
    return raw != null && raw !== "" && Number.isFinite(Number(raw)) ? money.format(Number(raw)) : t(copy.noValue);
  }
  const th = { padding: "8px 12px", textAlign: "start", fontSize: 11, fontWeight: 600, letterSpacing: "0.04em", textTransform: "uppercase", color: "var(--rd-text-tertiary)", background: "var(--rd-surface-soft)", borderBottom: "1px solid var(--rd-line-header)" } as const;
  const td = { padding: "8px 12px", borderBottom: "1px solid var(--rd-line-row)" } as const;
  return <div style={{ maxWidth: "100%", overflowX: "auto", borderRadius: "var(--rd-radius-card)", boxShadow: "var(--rd-shadow-card)" }}>
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
      <thead><tr><th style={th} scope="col">{t(copy.field)}</th><th style={th} scope="col">{t(after === undefined ? copy.real.currentState : copy.before)}</th>{after !== undefined ? <th style={th} scope="col">{t(copy.after)}</th> : null}</tr></thead>
      <tbody>{fields.filter(([section, field]) => before?.[section]?.[field] != null || after?.[section]?.[field] != null).map(([section, field]) => <tr key={`${section}.${field}`}>
        <th style={{ ...td, textAlign: "start", fontWeight: 400, color: "var(--rd-text-secondary)" }} scope="row">{t(copy.fields[`${section}_${field}` as keyof typeof copy.fields])}</th>
        <td style={td}><bdi className="rd-num">{value(field, before?.[section]?.[field])}</bdi></td>
        {after !== undefined ? <td style={{ ...td, fontWeight: 500 }}><bdi className="rd-num">{value(field, after?.[section]?.[field])}</bdi></td> : null}
      </tr>)}</tbody>
    </table>
  </div>;
}
